import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";
import AdminLoginModal from "../../components/admin/AdminLoginModal";
import { websitePaths } from "../../routes/websitePaths";
import { Link } from "react-router-dom";
import ClientLoginModal from "../../pages/client/ClientLogin";

const Footer: React.FC = () => {
  const [showLoginModal, setShowLoginModal] = React.useState(false);
  const [showLoginModalClient, setShowLoginModalClient] = React.useState(false);

  return (
    <footer className='site-footer pt-5 pb-3'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-4 mb-4'>
            <h5 className='fw-bold'>About</h5>
            <p>
              Dialin24 delivers residential and commercial construction with a
              focus on quality, timeline, and transparency.
            </p>
            <div className='d-flex gap-2 mt-3'>
              <a
                href='https://www.facebook.com/dialin24'
                target='_blank'
                rel='noopener noreferrer'
                className='btn btn-outline-light btn-sm social-btn'
                aria-label='Facebook'
              >
                <i className='bi bi-facebook'></i>
              </a>
              <a
                href='https://www.instagram.com/dialin24'
                target='_blank'
                rel='noopener noreferrer'
                className='btn btn-outline-light btn-sm social-btn'
                aria-label='Instagram'
              >
                <i className='bi bi-instagram'></i>
              </a>
              <a
                href='https://www.linkedin.com/company/dialin24'
                target='_blank'
                rel='noopener noreferrer'
                className='btn btn-outline-light btn-sm social-btn'
                aria-label='LinkedIn'
              >
                <i className='bi bi-linkedin'></i>
              </a>
              <a
                href='https://wa.me/918182833009'
                target='_blank'
                rel='noopener noreferrer'
                className='btn btn-outline-light btn-sm social-btn'
                aria-label='WhatsApp'
              >
                <i className='bi bi-whatsapp'></i>
              </a>
            </div>
          </div>

          <div className='col-md-3 mb-4'>
            <h3 className='h5 fw-bold mb-3'>Quick Links</h3>
            <ul className='list-unstyled'>
              <li className='mb-2'>
                <a href={websitePaths.home} className='footer-link'>
                  Home
                </a>
              </li>
              <li className='mb-2'>
                <a href={websitePaths.services} className='footer-link'>
                  Services
                </a>
              </li>
              <li className='mb-2'>
                <a href={websitePaths.projects.all} className='footer-link'>
                  Projects
                </a>
              </li>
              <li className='mb-2'>
                <a href={websitePaths.about} className='footer-link'>
                  About Us
                </a>
              </li>
              <li className='mb-2'>
                <a href={websitePaths.reviews.videos} className='footer-link'>
                  Reviews
                </a>
              </li>
            </ul>
          </div>

          <div className='col-md-2 mb-4'>
            <h3 className='h5 fw-bold mb-3'>Services</h3>
            <ul className='list-unstyled footer-muted'>
              <li className='mb-2'>Residential Construction</li>
              <li className='mb-2'>Commercial Projects</li>
              <li className='mb-2'>Renovation</li>
              <li className='mb-2'>Project Management</li>
            </ul>
          </div>

          <div className='col-md-3 mb-4'>
            <h5 className='fw-bold'>Contact</h5>
            <ul className='list-unstyled footer-muted'>
              <li>Email: info@dialin24.com</li>
              <li>Phone: +91 81828 33009</li>
              <li>Address: Lucknow, Uttar Pradesh</li>
              <li>Hours: Mon - Sat, 9:00 AM - 7:00 PM</li>
            </ul>
            <button
              type='button'
              className='btn footer-login-btn mt-3'
              onClick={() => setShowLoginModalClient(true)}
            >
              <i className='bi bi-kanban me-2'></i> Client Panel
            </button>
            <button
              type='button'
              className='btn footer-login-btn mt-3'
              onClick={() => setShowLoginModal(true)}
            >
              Admin Login
            </button>
          </div>
        </div>

        <div className='footer-bottom border-top pt-3 mt-3'>
          <div className='footer-copyright'>
            &copy; {new Date().getFullYear()} Dialin24. All rights reserved.
          </div>
          <div className='footer-credit'>
            Designed and developed by{" "}
            <a
              href='https://citydarsan.com'
              target='_blank'
              rel='noopener noreferrer'
              className='footer-credit-link'
            >
              citydarsan.com
            </a>
          </div>
        </div>
      </div>
      <AdminLoginModal
        show={showLoginModal}
        onHide={() => setShowLoginModal(false)}
      />
      <ClientLoginModal
        show={showLoginModalClient}
        onHide={() => setShowLoginModalClient(false)}
      />
    </footer>
  );
};

export default Footer;
